<script setup>
import { ElPopover } from "element-plus";
</script>
<template>
  <div v-bind="$attrs">
    <el-popover
      :width="220"
      popper-style="padding: 5px !important;z-index: 3000 !important"
    >
      <template #reference>
        <a
          class="text-untitled-gray-500 border-transparent hover:border-untitled-gray-300 border-b-2 hover:text-untitled-gray-700 px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium"
        >
          Resource Links
        </a>
      </template>
      <template #default>
        <div class="w-full flex flex-col justify-start items-start">
          <div class="w-full">
            <a
              href="https://hudsonauto.sharepoint.com/sites/HudsonAutoGroupLearningandDevelopment/SitePages/Events.aspx"
              target="_blank"
              class="w-full px-2 py-2 hover:bg-gray-200 text-sm text-untitled-gray-700 flex justify-start items-start"
              >Hudson Learning Calendar</a
            >
          </div>
          <div class="w-full">
            <a
              href="https://www.cdkglobaluniversity.com/learn"
              target="_blank"
              class="w-full px-2 py-2 hover:bg-gray-200 text-sm text-untitled-gray-700 flex justify-start items-start"
              >CDK Global University</a
            >
          </div>
          <div class="w-full">
            <a
              href="https://forms.office.com/r/MB6Q2DxBPE"
              target="_blank"
              class="w-full px-2 py-2 hover:bg-gray-200 text-sm text-untitled-gray-700 flex justify-start items-start"
              >CDK Virtual Instructor Led Training</a
            >
          </div>
          <div class="w-full">
            <a
              href="https://training.knowbe4.com/ui/login"
              target="_blank"
              class="w-full px-2 py-2 hover:bg-gray-200 text-sm text-untitled-gray-700 flex justify-start items-start"
              >Owl Testing Center</a
            >
          </div>
          <div class="w-full">
            <a
              href="https://www.paycomonline.net/v4/ee/web.php/app/login"
              target="_blank"
              class="w-full px-2 py-2 hover:bg-gray-200 text-sm text-untitled-gray-700 flex justify-start items-start"
              >Paycom</a
            >
          </div>
          <div class="w-full">
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=UF_wiSET2EuSbQJzNABvz5J-H5uKl79AuYNjkVP8h3BUN1pQSVFBMUZSRkxBRFc0S040UUhHWEI3Uy4u"
              target="_blank"
              class="w-full px-2 py-2 hover:bg-gray-200 text-sm text-untitled-gray-700 flex justify-start items-start"
              >CDK Certification</a
            >
          </div>
        </div>
      </template>
    </el-popover>
    <WeeklyReportSettings />
  </div>
</template>
<style lang="scss" scoped></style>
